import PropTypes from 'prop-types'
import {JsonViewer} from '../../../../../../../common/JsonViewer.jsx'
import {HeaderTitle} from '../../../../../../../common/HeaderTitle.jsx'
import {KamienieMiloweRepeater} from "../parts/KamienieMiloweRepeater.jsx"
export const KamienieMilowe = (props) => {
    // const allow = {
    //     hide: {},
    // }

    return (
        <>
            <JsonViewer src={props.wiz?.form || {}} show={true}/>

            <HeaderTitle noHr size={'fs-3'} title={'Kamienie milowe'}/>

            <HeaderTitle
                noHr
                size={'fs-4'}
                title={'Wprowadź informacje o kamieniach milowych projektu'}
            />

            <div className={'d-flex flex-column gap-3'}>
                <KamienieMiloweRepeater wiz={props.wiz} parentListName={'kamienie_list'}/>
            </div>
        </>
    )
}

KamienieMilowe.propTypes = {
    wiz: PropTypes.any,
}